import React from 'react';
import Box from '@mui/material/Box';
import SubscriptionModel from '../../../../../models/subscription.model';
import FormErrorText from '../../../../../common/form-error-text/form-error-text';
import { useTranslation } from 'react-i18next';
import { EMAILS } from '../../../../../common/constants/emails';

interface SubscriptionItemProps extends SubscriptionModel {
  planName?: string;
  chargeAmount: string;
  chargeCurrency: string;
  chargeDate: string;
}

const SubscriptionItem = (props: SubscriptionItemProps) => {
  const {
    planName,
    startDate,
    currentPeriodStart,
    currentPeriodEnd,
    status,
    errorTextArray,
    discount,
    chargeAmount,
    chargeCurrency,
    chargeDate,
  } = props;
  const { t } = useTranslation();
  return (
    <div className='subscription-info'>
      <div className='info-row'>
        <div className='item-label'>{t('labels.plan')}:</div>
        <div className='item-value'>
          <div>{planName}</div>
          <div>
            <a
              id='subscriptionItemMoreInfoLink'
              style={{ color: '#152a58' }}
              href='https://www.businesskitz.com/pricing'
              target='_blank'
              rel='noreferrer'
            >
              {t('moreInfoLink')}
            </a>
          </div>
        </div>
      </div>
      <div className='info-row'>
        <div className='item-label'>{t('labels.startDate')}:</div>
        <div className='item-value'>{startDate}</div>
      </div>
      <div className='info-row'>
        <div className='item-label'>{t('labels.currentPeriodStart')}:</div>
        <div className='item-value'>{currentPeriodStart}</div>
      </div>
      <div className='info-row'>
        <div className='item-label'>{t('labels.currentPeriodEnd')}:</div>
        <div className='item-value'>{currentPeriodEnd}</div>
      </div>
      <div className='info-row'>
        <div className='item-label'>{t('labels.nextPayment')}:</div>
        <div className='item-value'>
          {t('messages.yourNextPayment')}{' '}
          <Box component='span' sx={{ fontWeight: 700 }}>
            {chargeAmount}
          </Box>
          &nbsp;
          <Box component='span' sx={{ fontWeight: 700, textTransform: 'uppercase' }}>
            {chargeCurrency}
          </Box>{' '}
          {t('messages.deducted')}{' '}
          <Box component='span' sx={{ fontWeight: 700 }}>
            {chargeDate}
          </Box>
          .
        </div>
      </div>
      {discount && discount.coupon && (
        <>
          <div className='info-row'>
            <div className='item-label'>{t('labels.termsOfSubscription')}:</div>
            <div className='item-value'>{discount.coupon.duration_in_months}</div>
          </div>
        </>
      )}
      <div className='info-row'>
        <div className='item-label'>{t('labels.status')}:</div>
        <div className='item-value status-value'>{status}</div>
      </div>
      <div className='info-row'>
        <p className='disclaimer-text'>
          {t('messages.contact.subscriptionTab')}
          <a id='subscriptionItemSupportEmailLink' href={'mailto:' + EMAILS.SUPPORT_EMAIL}>
            {EMAILS.SUPPORT_EMAIL}
          </a>
          .
        </p>
      </div>
      <FormErrorText errorTextArray={errorTextArray} />
    </div>
  );
};

export default SubscriptionItem;
